module.exports = __webpack_public_path__ + "img/何时可以捐献.19be656c.png";